import { LoadingOutlined } from '@ant-design/icons'
import { ProviderAccount } from '@prisma/client'
import { Spin } from 'antd'

type Props = {
  onComplete: (account: ProviderAccount) => void
}

export const StepOne: React.FC<Props> = ({ onComplete }) => {
  // const { authUrl, profileName, onResetProfile, isLoading } = useAuthentication(
  //   {
  //     onComplete,
  //   },
  // )

  // if (isLoading) {
  return (
    <Spin
      indicator={<LoadingOutlined spin />}
      style={{ margin: '10px auto' }}
    />
  )
  // }

  // if (profileName && authUrl) {
  //   return (
  //     <>
  //       <Typography.Title level={5}>{profileName}</Typography.Title>
  //       <Typography.Text>
  //         Redirecting you to Ayrshare. If this doesn't happen click{' '}
  //         <Link to={authUrl} target="_blank" rel="noreferrer">
  //           here
  //         </Link>
  //         .
  //       </Typography.Text>
  //     </>
  //   )
  // }

  return <></>
}
